import { render, staticRenderFns } from "./PreLaunchView.vue?vue&type=template&id=634e0c87&scoped=true"
import script from "./PreLaunchView.vue?vue&type=script&lang=js"
export * from "./PreLaunchView.vue?vue&type=script&lang=js"
import style0 from "./PreLaunchView.vue?vue&type=style&index=0&id=634e0c87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634e0c87",
  null
  
)

export default component.exports